import { useContext } from '@wordpress/element';
import UserContext from '../context/context';

const Header = () => {
    const context = useContext(UserContext);
    const { classTier } = context;

    const displayClassTier = classTier => {
        if ('Lower' === classTier) {
            return 'lower-income';
        }
        if ('Middle' === classTier) {
            return 'middle-income';
        }
        if ('Upper' === classTier) {
            return 'upper-income';
        }
    };

    const displayColor = () => {
        if ('Lower' === classTier) {
            return 'low_dy';
        }
        if ('Middle' === classTier) {
            return 'mid_dy';
        }
        if ('Upper' === classTier) {
            return 'up_dy';
        }
    };

    const displayClassText = classTier => {
        if ('Lower' === classTier) {
            return (
                <div className="dynamic_headline" id="default_headline">
                    The share of adults in the{' '}
                    <span id={displayColor(classTier)}>
                        {displayClassTier(classTier)}
                    </span>{' '}
                    tier was highest in Laredo, TX and Brownsville-Harlingen, TX
                    (47%) and lowest in Wausau, WI, Sheboygan, WI and Barnstable
                    Town, MA (18%).
                    <br />
                </div>
            );
        }
        if ('Middle' === classTier) {
            return (
                <div className="dynamic_headline" id="default_headline">
                    The share of adults in the{' '}
                    <span id={displayColor(classTier)}>
                        {displayClassTier(classTier)}
                    </span>{' '}
                    tier was highest in Wausau, WI (67%) and lowest in Monroe,
                    LA (42%). Middle-income adults lacked a majority in 50
                    metropolitan areas.
                    <br />
                </div>
            );
        }
        if ('Upper' === classTier) {
            return (
                <div className="dynamic_headline" id="default_headline">
                    The share of adults in the{' '}
                    <span id={displayColor(classTier)}>
                        {displayClassTier(classTier)}
                    </span>{' '}
                    tier was highest in Midland, TX (37%) and lowest in Laredo,
                    TX, McAllen-Edinburg-Mission, TX, Las Cruces, NM and
                    Visalia-Porterville, CA (9%).
                    <br />
                </div>
            );
        }
    };
    return displayClassText(classTier);
};

export default Header;
